<app-layout-crud-index
  [titulo]="title"
  [length]="length"
  [dataSource]="dataSource"
  [filterFields]="filterFields"
  [filterInitialValues]="filterFormValues"
  [configColumns]="configColumns"
  [displayedColumns]="displayedColumns"
  (onChangePage)="changePage($event)"
  (onFilter)="filter($event)"
  (onSubmitAdvancedFilter)="submitAdvancedFilter($event)"
  (onResetFilter)="resetFilter()"
  (onOpenShow)="_openShow($event)"
  (onOpenNew)="_openNew($event)"
  (onOpenEdit)="_openEdit($event)"
  (onOpenDelete)="openDelete($event)"
  (onSelectionChange)="onSelectionChange($event)"
  (settings)="openSettings($event)">
  <app-customer-table
    table
    [length]="length"
    (changePage)="changePage($event)"
    (filter)="filter($event)"
    [displayedColumns]="displayedColumns"
    [dataSource]="dataSource"
    [configColumns]="configColumns"
    [initialFilterValue]="params.filter"
    [totalizers]="totalizers"
    [showLock]="true"
    [showActive]="true"
    [showKey]="true"
    [lockProperty]="'isLock'"
    [activeProperty]="'isActive'"
    (openShow)="_openShow($event)"
    (openNew)="_openNew($event)"
    (openEdit)="_openEdit($event)"
    (openDelete)="delete($event)"
    (lock)="lock($event)"
    (unlock)="unlock($event)"
    (active)="active($event)"
    (inactive)="inactive($event)"
    (key)="key($event)"
    (contract)="openContractsModal($event)"
    (onSelect)="_select($event)"
    (onSelectionChange)="onSelectionChange($event)"
    [showMoney]="true"
    [showDocumentPhoto] = "true"
    (DocumentPhoto)="OpenModalDocumentPhoto($event)"
    (moneyAction)="moneyAction($event)"
    (viewPlans)="viewClientPlans($event)"
    #table>
    <!-- <ng-template let-rowData="rawData">
      <app-customer-parcel-index
        fxFill
        [customerId]="rowData.id"
      ></app-customer-parcel-index>
    </ng-template> -->
  </app-customer-table>
  <div footer>
    <div fxFlex fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10">
      <div fxFlex="60" fxLayoutGap="4">
        <div fxFlex fxLayout="column" fxLayoutGap="4">
          <button
            fxFlex
            class="action-button"
            mat-raised-button
            (click)="generateContract()"
            [disabled]="!selection || selection?.source._selected?.length !== 1">
            GERAR CONTRATO
          </button>
          <div fxLayout="row" fxLayoutGap="4">
            <button
              fxFlex="50"
              class="action-button"
              mat-raised-button
              [disabled]="!selection || selection?.source._selected?.length != 1"
              (click)="generateParcel()">
              GERAR PARCELAS
            </button>

            <button
              fxFlex="50"
              class="action-button"
              mat-raised-button
              [disabled]="!selection"
              (click)="generateReports()">
              GERAR RELATÓRIO
            </button>
          </div>
        </div>
        <div fxFlex fxLayout="column" fxLayoutGap="4">
          <button disabled class="action-button" mat-raised-button>
            AVISO VENCIMENTO
          </button>
          <button disabled class="action-button" mat-raised-button>
            COBRAR VENCIDOS
          </button>
        </div>
        <div fxFlex fxLayout="column" fxLayoutGap="4">
          <button disabled class="action-button" mat-raised-button>
            AVISO BLOQUEIO
          </button>
          <button disabled class="action-button" mat-raised-button>
            COBRAR VENCIDOS
          </button>
        </div>
      </div>
      <div fxFlex="40" fxLayoutGap="4">
        <div fxFlex fxLayout="column" fxLayoutGap="4">
          <button disabled class="action-button" mat-raised-button>
            COBRAR A RECEBER
          </button>
          <button disabled class="action-button" mat-raised-button>
            CONTAS RECEBIDAS
          </button>
        </div>
        <div fxFlex fxLayout="column" fxLayoutGap="4">
          <button class="action-button" (click)="updatePlans()"
            mat-raised-button>
            ATUALIZAR PLANOS
          </button>
          <div fxFlex="55" fxLayout="row" fxLayoutGap="4">
            <button
              [disabled]="!selection || selection?.source._selected?.length != 1"
              fxFlex="50" class="action-button" mat-raised-button
              *ngIf="permissionService.is(permissionService.systemActionRoles.CUSTOMER_GENERATE_ACCESS_BUTTON_SHOW)"
              [disabled]="(!selection || selection?.source._selected?.length != 1) || !permissionService.is(permissionService.systemActionRoles.CUSTOMER_GENERATE_ACCESS_BUTTON_ENABLED)"
              fxFlex="50"
              class="action-button"
              mat-raised-button
              (click)="generateAcess()">
              GERAR ACESSO
            </button>
            <button
              *ngIf="permissionService.is(permissionService.systemActionRoles.CUSTOMER_ACCESSES_BUTTON_SHOW)"
              [disabled]="!permissionService.is(permissionService.systemActionRoles.CUSTOMER_ACCESSES_BUTTON_ENABLED)"
              class="action-button"
              (click)="customerAcess()"
              mat-raised-button>
              ACESSOS
            </button>

          </div>
        </div>
      </div>
    </div>
  </div>
</app-layout-crud-index>
